import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';

import {
  CurrencyComponent,
  DateMonthWithYearComponent,
  ExternalLinkComponent,
  getColumnKey,
  Icon,
  IconComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { AdminShippingMethodCollectionFilter } from '../../models/admin-shipping-method-collection-filter';
import { Guid, isNil, isNotNil } from '@web/utils';
import { AdminOrderCollectionItem } from '../../models/admin-order-collection-item';
import {
  OrderStatusComponent,
  RefundedPriceComponent,
  ShipmentStatusComponent,
} from '@web/shared/module/shop';
import { Tooltip } from 'primeng/tooltip';
import { Button } from 'primeng/button';
import { AdminOrderDataSourceService } from '../../services/admin-order-data-source.service';
import { AdminInvoiceDataSourceService } from '../../services/admin-invoice-data-source.service';

@Component({
  selector: 'app-admin-order-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    OrderStatusComponent,
    IconComponent,
    Tooltip,
    ExternalLinkComponent,
    ShipmentStatusComponent,
    NoDataComponent,
    Button,
    DateMonthWithYearComponent,
    RefundedPriceComponent,
    CurrencyComponent,
  ],
  templateUrl: './admin-order-list-custom-cell-template.component.html',
  styleUrl: './admin-order-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminOrderListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminOrderCollectionItem, AdminShippingMethodCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminOrderCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminOrderCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Icon = Icon;
  protected readonly isNil = isNil;

  private readonly orderDataSource = inject(AdminOrderDataSourceService);
  private readonly invoiceDataSource = inject(AdminInvoiceDataSourceService);

  public handleDownloadLabelClick(shipmentId: Guid): void {
    const orderId = this.model().id;

    this.orderDataSource.downloadLabelFor({ orderId, shipmentId }).subscribe();
  }

  public handleDownloadInvoiceClick(invoiceId: Guid): void {
    this.invoiceDataSource.downloadOrderInvoiceById(invoiceId).subscribe();
  }
}
